import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue'
import { Timesheets } from '../../types/timers'
import TimelineScorecard from '../TimelineScorecard.vue'
import { formatTimesheetsForTable } from '../../store/timesheets'
import { useFormatTime } from '../../composables/formatTime'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import { Table } from '../../types/components/data-rendering'
import BaseModal from '../wrappers/BaseModal.vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviousActivitiesScorecardTotalTime',
  props: {
    timesheets: {}
  },
  setup(__props: any) {

const props = __props

//translations
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`payPeriod.${key}`)
const form = (key: string) => t(`form.${key}`)

const totalTime = computed(() => {
  const data = props.timesheets.reduce((acc, timesheet) => {
    return acc + timesheet.toBePaidHours
  }, 0)

  return useFormatTime(data, { format: 'h:mm', initTime: 'minutes' })
})

const activities = computed((): Table => {
  return formatTimesheetsForTable(props.timesheets)
})
const value = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TimelineScorecard, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (value.value = true)),
      header: label('toBePaidHours'),
      subheader: totalTime.value
    }, null, 8, ["header", "subheader"]),
    (activities.value)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 0,
          modelValue: value.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event))
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(`${form('total')}: ${totalTime.value}`), 1)
          ]),
          content: _withCtx(() => [
            _createVNode(FilteringDataDisplay, {
              "table-data": activities.value,
              "enable-filters": false
            }, null, 8, ["table-data"])
          ]),
          actions: _withCtx(() => [
            _withDirectives(_createVNode(_component_q_btn, {
              rounded: "",
              flat: "",
              label: form('close')
            }, null, 8, ["label"]), [
              [_directive_close_popup]
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})